import React from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { DepartmentShape } from "../shapes/department-shape";
import { OrganizationShape } from "../shapes/organization-shape";
import { CustomTooltip } from "../tooltip/custom-tooltip";

export const ScatterChartContainer = ({
  departmentData,
  orgData,
  loading,
  isError,
  error,
  // Optional axis customization
  xLabel = "Acknowledged (%)",
  yLabel = "Logged (%)",
  xUnit = "%",
  yUnit = "%",
  xDomain = [0, 100],
  yDomain = [0, 100],
  xTicks = [0, 20, 40, 60, 80, 100],
  yTicks = [0, 20, 40, 60, 80, 100],
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-[500px]">
        <div className="text-sm text-muted-foreground">
          Loading chart data...
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex items-center justify-center h-[500px]">
        <div className="text-sm text-red-500">
          {error?.message || "Failed to fetch chart data"}
        </div>
      </div>
    );
  }

  return (
    <div className="h-[500px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart
          margin={{
            top: 20,
            right: 20,
            bottom: 60,
            left: 60,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            dataKey="x"
            name={xLabel}
            unit={xUnit}
            domain={xDomain}
            label={{
              value: xLabel,
              position: "insideBottom",
              offset: -10,
            }}
            ticks={xTicks}
          />
          <YAxis
            type="number"
            dataKey="y"
            name={yLabel}
            unit={yUnit}
            domain={yDomain}
            label={{
              value: yLabel,
              angle: -90,
              position: "insideLeft",
            }}
            ticks={yTicks}
          />
          <Tooltip
            cursor={{ strokeDasharray: "3 3" }}
            content={CustomTooltip}
          />
          {/* Department scatter points */}
          <Scatter
            data={departmentData}
            name="Departments"
            shape={<DepartmentShape />}
          />
          {/* Organization average */}
          {orgData && (
            <Scatter
              data={[orgData]}
              name="Organization"
              shape={<OrganizationShape />}
            />
          )}
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};
